var _defs, _path, _path2, _path3, _path4, _path5, _line, _path6, _path7, _line2, _path8, _polyline, _polyline2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRobotWaiting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4{fill:none;stroke:#1a242d;stroke-miterlimit:10;}.cls-1,.cls-3{stroke-width:0.9px;}.cls-2,.cls-4{stroke-width:0.5px;}.cls-3,.cls-4{stroke-linecap:round;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "_") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.14,15.91h3.91a2.83,2.83,0,0,1,2.83,2.83V20.2a1.62,1.62,0,0,1-1.62,1.62H6A1.62,1.62,0,0,1,4.35,20.2V18.69a2.78,2.78,0,0,1,2.78-2.78Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.88,21c0,.32,0-1.07,0,0,0,1.33-.15,2.41-.33,2.41s-.31-.85-.33-2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5,21.46c0,1.12-.17,2-.33,2S4.35,22.34,4.35,21v-.52"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.56,17.92s1-1.19,1.79,0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.73,19.41H10.82a2.23,2.23,0,0,1-3.24,0H4.35"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 11.22,
    y1: 13.98,
    x2: 11.22,
    y2: 15.91
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M6.92,15.91V1.68A1,1,0,0,1,7.85.58h2.43a1,1,0,0,1,.94,1.08V3.32"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.85,17.92s1-1.19,1.79,0"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 4.69,
    y1: 19.1,
    x2: 13.55,
    y2: 19.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11.24,6.76a5.2,5.2,0,1,1-.19,3.52"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "10.48 4.83 11.14 7.04 13.55 6.29"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "16.03 5.93 16.03 8.78 19.09 10.12"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotWaiting);
export default __webpack_public_path__ + "static/media/robot_waiting.c906ed1836e708c6dc390d8c914914ad.svg";
export { ForwardRef as ReactComponent };